import { IsOptional, IsString } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateLessonStatusDto {
  @ApiPropertyOptional({ type: 'string', description: 'Code du statut de leçon' })
  @IsOptional()
  @IsString()
  code?: string

  @ApiPropertyOptional({ type: 'string', description: 'Nom du statut de leçon' })
  @IsOptional()
  @IsString()
  name?: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
